import { Component, OnInit, Input } from '@angular/core';
import { MasterDetailComponent } from '../master-detail/master-detail.component';

@Component({
  selector: 'app-address-detail',
  templateUrl: './address-detail.component.html',
  styles: []
})
export class AddressDetailComponent extends MasterDetailComponent {

  @Input() dataId: string

  address = null
  provice = null
  amphur = null
  district = null

  async ngOnInit() {

    if (this.dataId) {
      this.address = await this.fetch(this.dataId)
    }
    console.log(this.address);
  }

  fetch(id) {

    return this.ERPAPI.get('hr/address/' + id).then(res => res.object)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/detail/address-detail/address-detail.component.ts